import { motion } from "framer-motion";
import ServiceCard from "./ServiceCard";
import { FaWhatsapp } from "react-icons/fa";
import {
  digitalSolutions,
  enterpriseSolutions,
} from "../data/services";
import SectionHeading from "./SectionHeading";

const Services = () => {
  return (
    <section className="relative overflow-hidden bg-[#F8FAFC] py-12 md:py-16">

      {/* Background Blur */}
      <div className="absolute -left-32 top-0 h-72 w-72 md:h-96 md:w-96 rounded-full bg-pink-100 blur-[120px] md:blur-[140px] opacity-40"></div>

      <div className="absolute -right-32 bottom-0 h-72 w-72 md:h-96 md:w-96 rounded-full bg-cyan-100 blur-[120px] md:blur-[140px] opacity-40"></div>

      {/* Grid Pattern */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            "linear-gradient(#000 1px, transparent 1px), linear-gradient(to right,#000 1px,transparent 1px)",
          backgroundSize: "50px 50px",
        }}
      />

      <div className="relative mx-auto max-w-6xl px-4 sm:px-5 md:px-6">

        {/* Main Heading */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mx-auto mb-12 md:mb-20 max-w-3xl text-center"
        >
          <SectionHeading
            badge="Our Services"
            title="Comprehensive"
            highlight="IT Solutions"
            description="From digital transformation to enterprise infrastructure, we deliver innovative solutions."
          />
        </motion.div>

        {/* ================= ENTERPRISE SOLUTIONS ================= */}

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >

          <div className="mb-10 md:mb-14 text-center">

            <span className="inline-block rounded-full bg-pink-100 px-4 py-1.5 md:px-5 md:py-2 text-[11px] sm:text-xs md:text-sm font-semibold uppercase tracking-wider text-[#b31159]">
              Enterprise IT Solutions
            </span>

            <h3 className="mt-3 md:mt-5 text-xl sm:text-2xl md:text-3xl font-bold text-slate-900">
              Secure & Scalable Enterprise Technology
            </h3>

            <p className="mx-auto mt-3 md:mt-5 max-w-3xl text-sm sm:text-base md:text-lg leading-6 md:leading-8 text-slate-600">
              Empower your organization with enterprise-grade software,
              networking, security, cloud, and audio-visual solutions
              tailored for modern businesses.
            </p>

          </div>

          <div className="grid gap-5 md:gap-8 md:grid-cols-2 xl:grid-cols-3">

            {enterpriseSolutions.map((service, index) => (

            <ServiceCard
            key={service.id}
            service={service}
            index={index + digitalSolutions.length}
            showLearnMore={true}
            />

            ))}

          </div>

        </motion.div>

        {/* Divider */}

        <div className="relative my-8 md:my-16 lg:my-24 flex items-center justify-center">

          <div className="absolute h-px w-full bg-slate-200"></div>

          <div className="relative rounded-full bg-white px-5 py-2 md:px-8 md:py-3 shadow-md">

            <span className="text-sm md:text-base font-semibold text-slate-700">
              Digital Solutions
            </span>

          </div>

        </div>

        {/* ================= DIGITAL SOLUTIONS ================= */}

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 md:mb-28"
        >

          <div className="mb-10 md:mb-14 text-center">

            <span className="inline-block rounded-full bg-pink-100 px-4 py-1.5 md:px-5 md:py-2 text-[11px] sm:text-xs md:text-sm font-semibold uppercase tracking-wider text-[#b31159]">
              Digital Solutions
            </span>

            <h3 className="mt-3 md:mt-5 text-xl sm:text-2xl md:text-3xl font-bold text-slate-900">
              Build Your Digital Presence
            </h3>

            <p className="mx-auto mt-3 md:mt-5 max-w-3xl text-sm sm:text-base md:text-lg leading-6 md:leading-8 text-slate-600">
              Accelerate your business with websites, mobile applications,
              AI automation, and digital marketing solutions designed to
              drive growth.
            </p>

          </div>

          <div className="grid gap-5 md:gap-8 md:grid-cols-2 xl:grid-cols-3">

            {digitalSolutions.map((service, index) => (
              <ServiceCard
                key={service.id}
                service={service}
                index={index}
                showLearnMore={false}
              />

            ))}

          </div>

        </motion.div>
                {/* ================= CTA ================= */}

                <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-16 md:mt-28"
        >
          <div className="overflow-hidden rounded-[24px] md:rounded-[32px] bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-[1px] shadow-[0_20px_60px_rgba(15,23,42,.18)]">

            <div className="rounded-[23px] md:rounded-[31px] bg-slate-900 px-5 sm:px-6 md:px-10 py-8 md:py-14">

              <div className="flex flex-col items-center justify-between gap-6 md:gap-8 lg:flex-row">

                {/* Left Content */}

                <div className="max-w-2xl text-center lg:text-left">

                  <span className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] sm:text-xs font-medium tracking-wide text-pink-300">
                    Free IT Consultation
                  </span>

                  <h3 className="mt-4 text-xl sm:text-3xl font-bold leading-tight text-white">
                    Let's Build Something Amazing Together
                  </h3>

                  <p className="mt-3 md:mt-5 text-sm sm:text-base md:text-lg leading-6 md:leading-8 text-slate-300">
                    Whether you're looking for digital transformation,
                    enterprise IT infrastructure, AI automation, or business
                    software, our experts are ready to help you choose the
                    right solution.
                  </p>
                </div>

                {/* Right Button */}

                <motion.button
                  whileHover={{
                    scale: 1.05,
                    y: -3,
                  }}
                  whileTap={{
                    scale: 0.95,
                  }}
                  onClick={() =>
                    window.open(
                      "https://wa.me/917897648842?text=Hi%20Samrat%20Tech%20IT%20Solutions,%20I%20need%20a%20free%20consultation.",
                      "_blank"
                    )
                  }
                  className="group inline-flex items-center gap-2 md:gap-3 rounded-xl md:rounded-2xl bg-[#25D366] px-5 sm:px-6 md:px-8 py-3 md:py-4 text-sm md:text-base font-semibold text-white shadow-[0_12px_35px_rgba(37,211,102,.35)] transition-all duration-300 hover:bg-[#20ba5a] hover:shadow-[0_18px_45px_rgba(37,211,102,.45)]"
                >
                  <FaWhatsapp className="text-lg md:text-2xl transition-transform duration-300 group-hover:scale-110" />

                  <span>Chat on WhatsApp</span>
                </motion.button>

              </div>

            </div>

          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Services;